<button
  type="button"
  class="icon-btn"
  [class.icon-btn--active]="active"
  [class.icon-btn--disabled]="disabled"
  [matTooltip]="alt ?? ''"
  [attr.aria-label]="alt"
  (click)="handleClick($event)">
  @if (imgSrc) {
    <img [src]="imgSrc" [alt]="alt ?? ''" class="icon-btn__img">
  } @else if (icon) {
    <mat-icon class="icon-btn__mat-icon material-symbols-outlined">{{ icon }}</mat-icon>
  }
</button>
